import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=1769a332&scoped=true&"
import script from "./channelDetail.vue?vue&type=script&lang=ts&"
export * from "./channelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./channelDetail.vue?vue&type=style&index=0&id=1769a332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1769a332",
  null
  
)

export default component.exports